module.exports = __webpack_public_path__ + "img/Availability Tracking.5eab6d07.svg";